import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ModalController,
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { backspaceSharp } from 'ionicons/icons';

import { LeaderboardService } from 'projects/tools/src/lib/shared-module/leaderboard/leaderboard.service';
import { DeviceDetectorService } from 'ngx-device-detector';

import { LeaderboardTabsComponent } from 'projects/tools/src/lib/shared-module/leaderboard-tabs/leaderboard-tabs.component'; // lib-app-leaderboard-tabs
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-leaderboard-info-modal',
  templateUrl: './leaderboard-info-modal.component.html',
  styleUrls: ['./leaderboard-info-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonButton,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonRow,
    IonTitle,
    IonToolbar,
    LeaderboardTabsComponent,
    TranslateModule,
  ],
})
export class LeaderboardInfoModalComponent {
  constructor(
    private ionicModal: ModalController,
    public leaderboard: LeaderboardService,
    public device: DeviceDetectorService
  ) {
    addIcons({ backspaceSharp });
  }

  public closeModal() {
    this.ionicModal.dismiss();
  }
}
